import { render } from "./languageSelect.vue?vue&type=template&id=0219e5c1&scoped=true"
import script from "./languageSelect.vue?vue&type=script&lang=ts"
export * from "./languageSelect.vue?vue&type=script&lang=ts"

import "./languageSelect.vue?vue&type=style&index=0&id=0219e5c1&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-0219e5c1"

export default script